import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { PersonalComponent } from './personal/personal.component';
import { PaymentComponent } from './payment/payment.component';
import { PatientDetailsComponent } from './patient-details.component';
// import { AngularFontAwesomeModule } from 'angular-font-awesome';
// import { NgxSelectModule } from 'ngx-select-ex';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ToastrService } from 'ngx-toastr';
import { ToasterService } from 'src/app/services/toaster.service';
const routes: Routes = [
    // { path: 'patient/', component: PatientDetailsComponent },
    // { path: 'patient/personal/:token', component: PersonalComponent },
    // { path: 'patient/payment/:token', component: PaymentComponent }
];
@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        // TextMaskModule,
        // AngularFontAwesomeModule,
        // NgxSelectModule,
        // SignaturePadModule,
        BsDatepickerModule.forRoot(),
        ModalModule.forRoot(),
        // TypeaheadModule.forRoot(),
    ],
    declarations: [
        PersonalComponent,
        PaymentComponent,
        PatientDetailsComponent
    ],
    exports: [
        RouterModule
    ],
    providers: [
        DatePipe,
        ToasterService,
        ToastrService,
        {
    provide: BsDatepickerConfig,
    useValue: undefined
}]
})
export class PatientModule { }



